import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IIndicationsStatus } from '@/pages/Partners/types';

export interface ICoors {
  x: number;
  y: number;
}

export interface IModal {
  open: boolean;
  coors: ICoors;
}

export interface PortfolioState {
  isShowAll: boolean;
  modal: IModal;
  activeFilter?: IIndicationsStatus;
}

const initialState: PortfolioState = {
  isShowAll: true,
  modal: {
    open: false,
    coors: {
      x: 0,
      y: 0,
    },
  },
  activeFilter: undefined,
};

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    setIsShowAll(state, action: PayloadAction<boolean>) {
      state.isShowAll = action.payload;
    },
    openModal(state, action: PayloadAction<ICoors>) {
      state.modal = {
        open: true,
        coors: action.payload,
      };
    },
    closeModal(state) {
      state.modal = {
        open: false,
        coors: { x: 0, y: 0 },
      };
    },
    setActiveFilter(state, action: PayloadAction<IIndicationsStatus | undefined>) {
      state.activeFilter = action.payload;
    },
  },
});

export const { setIsShowAll, openModal, closeModal, setActiveFilter } = portfolioSlice.actions;
export default portfolioSlice.reducer;
